/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_ItalicInputs */

const en_common_editor_italic = /** @type {(inputs: Common_Editor_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italic`)
};

const zh_common_editor_italic = /** @type {(inputs: Common_Editor_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`斜体`)
};

/**
* | output |
* | --- |
* | "Italic" |
*
* @param {Common_Editor_ItalicInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_italic = /** @type {((inputs?: Common_Editor_ItalicInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_ItalicInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_italic(inputs)
	return zh_common_editor_italic(inputs)
});
export { common_editor_italic as "common.editor.italic" }